export default "__VITE_ASSET__Bp7$pQu$__"